import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { URL_BASE } from "../../../../../constants/url";
import { postFile } from "../../../../../utils/fetch";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../../../../utils/composeNotification";
import { startGetConcesionariosServicio } from "../../../../../context/actions/concesionariosActions";
import { notification } from "../../../../../context/actions/notificationActions";

export default function useUplaod() {
  const dispatch = useDispatch();
  const [body, setBody] = useState({});
  const { id } = useParams();

  //
  const handleClick = async () => {
    if (!body.nombre) return;
    if (!body.file) return;

    let formdata = new FormData();
    formdata.append("file", body.file);
    formdata.append("nombre", body.nombre);
    formdata.append("servicioID", id);

    formdata.append("mimetype", "application/pdf");

    var url = `${URL_BASE}/api/ConcesionadosFiles`;
    // const url = `${URL_PT}/UploadFiles/${id}?nombre=${body.nombre}`;
    const result = await postFile(url, formdata);

    if (result.code === 0) {
      dispatch(notification(composeSuccessNotification("Archivo cargado correctamente")));
      dispatch(startGetConcesionariosServicio(id, true));
      setBody({});
    } else {
      dispatch(
        notification(composeErrorNotification("UploadFiles", `${result.error}`))
      );
    }
  };

  const props = {
    beforeUpload: (file) => {
      setBody({ ...body, file });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  //
  const handleChange = ({ target }) =>
    setBody({ ...body, nombre: target.value });

  return { body, handleChange, handleClick, props };
}
